import { render, staticRenderFns } from "./TestHisto.vue?vue&type=template&id=2aa513eb&"
import script from "./TestHisto.vue?vue&type=script&lang=js&"
export * from "./TestHisto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports